module.exports = __webpack_public_path__ + "static/media/p3.5ca32652.mp4";